// extracted by mini-css-extract-plugin
export default {"chartWrapper":"PackageViewsStats_chartWrapper__xI4Fh"};